import { useAuthContext } from "@/contexts/auth";
import { useContactTracking } from "@/contexts/contact";
import { useTrackingAvDistributionType, useTrackingLeadForm } from "@/hooks";
const buildFormConsent = (data) => {
    const consents = [];
    if ("newsletterOptout" in data &&
        !data.newsletterOptout &&
        data.newsletterOptInPreference) {
        consents.push(`marketing_optout-${data.newsletterOptInPreference}`);
    }
    if (data.offerOptin) {
        consents.push("partner_optin");
    }
    return consents.join("|");
};
export const useSendLeadTracking = () => {
    const { authTrackingData } = useAuthContext();
    const { leadValue } = useContactTracking();
    const getAdditionalProps = (data, av_zone) => {
        const av_form_subscription_consent = buildFormConsent(data);
        return {
            additionalProps: {
                av_user: {
                    ...authTrackingData,
                    ...leadValue,
                    project: data.isOwner === true ? "IsOwner" : "Unknown",
                },
                av_attached_file: data.shareSeekerProfile ? "seeker_profile" : "none",
                av_form_subscription_consent,
                av_zone,
            },
        };
    };
    const distributionType = useTrackingAvDistributionType();
    const eventNameOk = distributionType === "1"
        ? "lead_classified_form_submit_rent"
        : "lead_classified_form_submit_buy";
    const eventNameConfirm = distributionType === "1"
        ? "lead_classified_form_confirm_rent"
        : "lead_classified_form_confirm_buy";
    const leadFormOk = useTrackingLeadForm({
        event: eventNameOk,
    });
    const leadFormConfirm = useTrackingLeadForm({
        event: eventNameConfirm,
    });
    return {
        leadFormOk,
        leadFormConfirm,
        getAdditionalProps,
    };
};
